import { render, staticRenderFns } from "./T2.vue?vue&type=template&id=c03cef58&"
import script from "./T2.vue?vue&type=script&lang=js&"
export * from "./T2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports